<template>
  <bpo2-pdf class="content section">

    <img
      class="smaller"
      src="@/assets/Quest-logo-plain_246x50.png"
    >

    <p>&nbsp;</p>

    <div class="card">
      <div class="card-content">
        <div class="level">
          <p class="subtitle">
            MFQA 2
          </p>
          {{ $store.state.bpo2.created | dateMedium() }} Created<br />
          {{ $store.state.bpo2.lastUpdate | dateMedium() }} Last Update
        </div>
      </div>
    </div>

    <Bpo2CalculatedResults />

    <div
      id="page_finished"
      class="page_finished"
    >&nbsp;</div>

  </bpo2-pdf>

</template>

<script>
import Bpo2CalculatedResults from "@/components/properties/evaluations/multifamily/BPO2CalculatedResults.vue";

export default {
  components: { Bpo2CalculatedResults },

  props: {
    property_id: undefined,
    bpo2_guid: undefined
  },

  data() {
    return {
      showHelpDealInputs: false,
      rentModal: false
    };
  },

  methods: {},

  async mounted() {
    this.$store.state.isLoginRequired = false;
    this.$store.state.isPdf = true;

    console.log(
      "mounted()",
      this.$route.params.property_id,
      this.$route.params.bpo2_guid
    );
    var propertyId = this.$route.params.property_id;
    var bpo2Guid = this.$route.params.bpo2_guid;

    console.log("bpo2Guid", bpo2Guid);

    // await this.$store.dispatch("getProperty", propertyId);
    await this.$store.dispatch("getBpo2ByGuid", { propertyId, bpo2Guid });
  },

  beforeDestroy() {
    this.$store.state.isLoginRequired = true;
  }
};
</script>

<style>
bpo2-pdf * {
  font-size: 11pt;
}
table {
  font-size: 90%;
}
td.align-right {
  text-align: right;
}
td.align-center {
  text-align: center;
}
td.header {
  font-weight: bold;
}
td.footer {
  font-weight: bold;
}
td.column-header {
  font-weight: bold;
  font-size: 120%;
}
tr.subtotal1 {
  font-weight: bold;
  font-size: 90%;
  border-top: 2px solid;
  border-bottom: 2px solid;
}
tr.subtotal2 {
  font-weight: bold;
  font-size: 110%;
  border-top: 2px solid;
  border-bottom: 2px solid;
}
tr.subtotal3 {
  font-weight: bold;
  outline: 2px solid;
  font-size: 120%;
}
.disclaimer {
  font-size: 80%;
  font-weight: bold;
}
.textarea {
  width: 250px;
  min-height: 50px;
  height: auto;
  border: 2px solid rgba(63, 63, 63, 1);
}
.smaller {
  width: 125px;
  height: auto;
}
</style>
